import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import translate from "react-i18next/dist/commonjs/translate";
import Widget from "./Widget";
import WidgetErrorMessage from "./WidgetErrorMessage";
import WidgetOverlay from "./WidgetOverlay";
import * as actions from "../dashboardActions";
import {
  getIncidentsIsLoading,
  getIncidentsHasErrors,
  getDashboardIncidents,
  getDashboardIncidentsSummary
} from "../dashboardSelector";
import Spinner from "../../common/progress/Spinner";
import { IncidentsMock, incidentsSummaryMock } from "./incidentsMockData";
import IncidentsWidgetTable from "./IncidentsWidgetTable";
import IncidentsWidgetSummary from "./IncidentsWidgetSummary";

export class IncidentsWidget extends React.Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

  componentDidMount() {
      if (this.props.customerInformation.plusCustomer) {
          this.props.actions.loadIncidents();
      } else {
          this.props.actions.loadIncidentsSuccess(IncidentsMock);
      }
  }

  onReload() {
    this.props.actions.loadIncidents();
  }

  render() {
    const {
      customerInformation,
      incidents,
      isLoading,
      hasErrors,
      t,
      incidentSummary
    } = this.props;

    if (isLoading) {
      return (
        <Widget
          header={t("incidentsWidgetTitle")}
          onReload={this.onReload}
          isLoading={isLoading}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
    }

    if (hasErrors) {
      return (
          <Widget header={t("incidentsWidgetTitle")}>
              <div className="overlay overlay-default">
                  <WidgetErrorMessage onClick={this.onReload} />
              </div>
          </Widget>
      );
    }

    if (!customerInformation.plusCustomer) {
      return (
        <Widget header={t("incidentsWidgetTitle")}>
          <WidgetOverlay buttonText={t("incidentsWidgetButtonText")} />
              <IncidentsWidgetTable incidents={incidents} />
              <IncidentsWidgetSummary incidentSummary={incidentSummary} />
        </Widget>
      );
    }

    return (
      <Widget header={t("incidentsWidgetTitle")} onReload={this.onReload}>
        <IncidentsWidgetTable incidents={incidents} />
        <IncidentsWidgetSummary incidentSummary={incidentSummary} />
      </Widget>
    );
  }
}

IncidentsWidget.propTypes = {
  incidents: PropTypes.array.isRequired,
  incidentSummary: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  customerInformation: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    incidents: getDashboardIncidents(state),
    incidentSummary: getDashboardIncidentsSummary(state),
    customerInformation: state.customerInformation,
    isLoading: getIncidentsIsLoading(state),
    hasErrors: getIncidentsHasErrors(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IncidentsWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/IncidentsWidget.js